import React from "react";
import { TeamLogo } from "../shared/TeamLogo";

const PlayerName = ({ player_id, player_name, className }) =>
  player_id ? (
    <a href={`/player/${player_id}`} target="_blank" rel="noreferrer" className={`${className} hover:text-blue-600 hover:underline`}>
      {player_name || "Unknown"}
    </a>
  ) : (
    <span className={className}>{player_name || "Unknown"}</span>
  );

const pos = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

export const BattingLineup = ({ lineup, teamName, teamId }) => {
  if (!lineup || lineup.length === 0) {
    return <div className="text-sm text-gray-400 italic">No lineup data available</div>;
  }

  const grouped = {};
  const orphanSubs = [];
  lineup.forEach((player) => {
    const order = player.bat_order || 0;
    if (order === 0 && player.is_sub) {
      orphanSubs.push(player);
      return;
    }
    if (!grouped[order]) grouped[order] = [];
    grouped[order].push(player);
  });

  const sortedOrders = Object.keys(grouped).sort((a, b) => Number(a) - Number(b));

  return (
    <div>
      <div className="flex items-center gap-2 pb-2 mb-2 border-b border-gray-200">
        <TeamLogo teamId={teamId} teamName={teamName} size="w-6 h-6" />
        <h3 className="text-sm font-semibold text-gray-800">{teamName}</h3>
      </div>
      <div>
        {sortedOrders.map((order) => {
          const players = grouped[order];
          const starter = players.find((p) => !p.is_sub);
          const subs = players.filter((p) => p.is_sub);

          return (
            <div key={order} className="border-b border-gray-100 last:border-0">
              {starter && (
                <div className="flex items-center gap-3 py-1.5 px-1">
                  <span className="w-5 text-right text-xs text-gray-400 shrink-0">{order}</span>
                  <PlayerName player_id={starter.player_id} player_name={starter.player_name} className="text-sm text-gray-800 flex-1 min-w-0 truncate" />
                  <span className="text-xs font-medium text-gray-400 shrink-0">{pos(starter.position)}</span>
                </div>
              )}
              {subs.map((sub, idx) => (
                <div key={idx} className="flex items-center gap-3 py-1 px-1 pl-8 bg-gray-50">
                  <span className="text-xs text-gray-300 shrink-0">↳</span>
                  <PlayerName player_id={sub.player_id} player_name={sub.player_name} className="text-sm text-gray-500 flex-1 min-w-0 truncate" />
                  <span className="text-xs font-medium text-gray-400 shrink-0">{pos(sub.position)}</span>
                </div>
              ))}
            </div>
          );
        })}
        {orphanSubs.map((sub, idx) => (
          <div key={`orphan-${idx}`} className="flex items-center gap-3 py-1 px-1 pl-8 bg-gray-50 border-b border-gray-100 last:border-0">
            <span className="text-xs text-gray-300 shrink-0">↳</span>
            <PlayerName player_id={sub.player_id} player_name={sub.player_name} className="text-sm text-gray-500 flex-1 min-w-0 truncate" />
            <span className="text-xs font-medium text-gray-400 shrink-0">{pos(sub.position)}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
